import type { SxProps, Theme, TypographyVariant } from "@mui/material";
import { Typography } from "@mui/material";

interface Props {
  value: string;
  variant: TypographyVariant;
  sx?: SxProps<Theme>;
}

export const MeasureCell = ({ value, variant, sx }: Props) => {
  return (
    <Typography
      variant={variant}
      sx={{
        ...sx,
      }}
    >
      {value}
    </Typography>
  );
};
